<template>
  <ListingsFilterControl label="Property type">
    <VDropdown
      :model-value="modelValue"
      :options="LISTINGS_TYPE_OPTIONS"
      @update:model-value="handleUpdateModelValue"
    />
  </ListingsFilterControl>
</template>

<script lang="ts" setup>
  // Types
  import type { PropType } from 'vue';
  import type { EPropertyCategory } from '~/misc/listings/types';
  import { EAnalyticsEvent } from '~/misc/services/analytics/types';

  // Config
  import { LISTINGS_TYPE_OPTIONS } from '~/misc/listings/config';

  // Utils
  import { eventBus } from '~/misc/utils/event-bus';

  // Components
  import ListingsFilterControl from '~/misc/listings/filters/control/ListingsFilterControl.vue';
  import VDropdown from '~/misc/v-dropdown';

  const emit = defineEmits<{
    (e: 'update:modelValue', value: EPropertyCategory | null): void;
  }>();

  defineProps({
    modelValue: {
      type: String as PropType<EPropertyCategory | null>,
      default: null,
    },
  });

  const handleUpdateModelValue = (value: EPropertyCategory | null) => {
    eventBus.emit(EAnalyticsEvent.DASHBOARD_FILTERS_PROPERTY_TYPE_CHANGED, { value });

    emit('update:modelValue', value);
  };
</script>
